import { useEffect } from 'react';

import {
  addBreadcrumbModal,
  ModalsList,
  ModeBreadcrumbModal,
} from '@/helpers/breadcrumbModal';

export const useAddBreadcrumbModal = (modal: ModalsList) => {
  useEffect(() => {
    addBreadcrumbModal(ModeBreadcrumbModal.OPEN, modal);

    return () => addBreadcrumbModal(ModeBreadcrumbModal.CLOSE, modal);
  }, [modal]);
};
